import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import AuthReducer from './auth/auth.reducer';
import SessionReducer from './session/session.reducer';
import DataReducer from './data/data.reducer';
import InspectionReducer from './inspection/inspection.reducer';

const persistConfig = {
  key: 'tisms.root',
  storage,
  // Auth, session AND the active inspection survive a reload — an inspector
  // who refreshes mid-visit must land back on the same branch, not on
  // whichever inspection happens to be in progress somewhere in the state.
  whitelist: ['auth', 'session', 'inspection'],
};

const rootReducer = combineReducers({
  auth: AuthReducer,
  session: SessionReducer,
  data: DataReducer,
  inspection: InspectionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default persistReducer(persistConfig, rootReducer);
